import React from 'react';
import { Form, Col, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import MaskedInput from 'react-text-mask';
import { FaMobileAlt } from 'react-icons/fa';
import { mask as masks } from '~/Utils/Helpers';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { UNIDADES } from '../constants';

// Estilo comum dos rótulos: sóbrio, em caixa alta, hierarquia clara.
const labelClasse = 'font-weight-bold text-secondary text-uppercase small mb-1';

const FormularioAssinatura = ({ formik, unidadeId, onChangeUnidade }) => {
  const { values, errors, touched, handleChange, handleBlur } = formik;

  const opcoesUnidade = UNIDADES.map(u => ({ value: u.id, label: u.label }));
  const celularInvalido = touched.celular && !!errors.celular;

  return (
    <>
      <Form.Group className="mb-4">
        <Form.Label className={labelClasse}>Unidade</Form.Label>
        <Select
          styles={customStyles}
          components={{ DropdownIndicator }}
          options={opcoesUnidade}
          value={opcoesUnidade.find(o => o.value === unidadeId) || null}
          onChange={opt => onChangeUnidade(opt ? opt.value : unidadeId)}
          isSearchable={false}
          placeholder="Selecione a unidade..."
        />
      </Form.Group>

      <Form.Row>
        <Form.Group as={Col} md={5} className="mb-3">
          <Form.Label className={labelClasse}>
            Nome <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            name="nome"
            value={values.nome}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Seu nome"
            isInvalid={touched.nome && !!errors.nome}
          />
          <Form.Control.Feedback type="invalid">{errors.nome}</Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md={4} className="mb-3">
          <Form.Label className={labelClasse}>Departamento</Form.Label>
          <Form.Control
            name="departamento"
            value={values.departamento}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Seu departamento"
            isInvalid={touched.departamento && !!errors.departamento}
          />
          <Form.Control.Feedback type="invalid">
            {errors.departamento}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md={3} className="mb-3">
          <Form.Label className={labelClasse}>Celular</Form.Label>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text>
                <FaMobileAlt />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <MaskedInput
              mask={masks.celular}
              guide={false}
              name="celular"
              value={values.celular}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="(00) 00000-0000"
              className={`form-control${celularInvalido ? ' is-invalid' : ''}`}
            />
          </InputGroup>
          {celularInvalido ? (
            <div className="invalid-feedback d-block">{errors.celular}</div>
          ) : (
            <Form.Text className="text-muted">
              Opcional — preencha só se quiser exibir.
            </Form.Text>
          )}
        </Form.Group>
      </Form.Row>

      <p className="text-muted font-italic small mb-0">
        <span className="text-danger">*</span> Campo obrigatório
      </p>
    </>
  );
};

export default FormularioAssinatura;
